module.exports = __webpack_public_path__ + "img/core-active-2.efe1bc2.png";